import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import {
  showInformationToast,
  withCookie,
  dismissAllToast
} from '@spotahome/ui-library';

import '@spotahome/ui-library/lib/components/Toast.css';

import TimerIcon from '@common/components/icons/TimerIcon';

import { changeFilterNames } from './utils';

const TOAST_GENERIC_EXIT_TIMEOUT = 10000;
const TOAST_EXIT_TIMEOUT = 20000;
const TOAST_ENTER_TIMEOUT = 3000;

const COOKIES_ACCEPTED_VALUE = '1';
const COOKIE_CONFIG = {
  cookieName: 'city-event-toast',
  cookieExpires: {
    days: 1
  }
};

const getConditionalDiscount = (cityDiscounts, updatedFilters) => {
  const newFilterNames = changeFilterNames(updatedFilters);
  const selectedDiscounts = cityDiscounts.flatMap(current => {
    const conditions = current.conditions;
    const value = current.discountValue;

    return conditions.map(condition => ({
      name: condition.value,
      value
    }));
  });

  const discountSelected = selectedDiscounts
    .filter(discount => newFilterNames.includes(discount.name))
    .map(discount => discount.name);

  return discountSelected.length === 1
    ? selectedDiscounts.find(
        discount => discount.name === discountSelected.toString()
      )
    : false;
};

const getGenericToastText = () => trans('discount.toast.generic.text');

const getToastProps = (conditionToastText, props) => {
  const conditionalDiscount = () =>
    getConditionalDiscount(props.discounts, props.updatedFilters);
  return {
    renderIcon: () => <TimerIcon />,
    renderContent: () => {
      return conditionToastText && conditionalDiscount()
        ? conditionToastText(conditionalDiscount())
        : getGenericToastText();
    }
  };
};

class CityDiscountsToast extends Component {
  componentDidMount() {
    if (
      this.props.discounts.length &&
      !this.props.isCookieAccepted(COOKIES_ACCEPTED_VALUE)
    ) {
      this.props.acceptCookie(COOKIES_ACCEPTED_VALUE);
      showInformationToast(getToastProps(), {
        autoClose: TOAST_GENERIC_EXIT_TIMEOUT,
        delay: TOAST_ENTER_TIMEOUT
      });
    }
  }

  componentDidUpdate(prevProps) {
    const conditionToastText = discount =>
      trans('discount.toast.type.property.text', {
        discountConditions: trans(
          `cityDiscounts.conditionType.${discount.name}`
        ),
        city: trans(`city.${this.props.city}`),
        discount: discount.value
      });

    const { updatedFilters } = this.props;

    if (prevProps.updatedFilters !== updatedFilters && updatedFilters.length) {
      this.props.acceptCookie(COOKIES_ACCEPTED_VALUE);
      dismissAllToast();
      setTimeout(() => {
        showInformationToast(getToastProps(conditionToastText, this.props), {
          autoClose: TOAST_EXIT_TIMEOUT,
          delay: TOAST_ENTER_TIMEOUT
        });
      }, 100);
    }
  }

  render() {
    return null;
  }
}

CityDiscountsToast.propTypes = {
  isCookieAccepted: PropTypes.func.isRequired,
  acceptCookie: PropTypes.func.isRequired,
  city: PropTypes.string.isRequired,
  updatedFilters: PropTypes.arrayOf(PropTypes.string),
  discounts: PropTypes.arrayOf(
    PropTypes.shape({
      conditions: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          value: PropTypes.string
        })
      ),
      discountValue: PropTypes.number
    })
  )
};

CityDiscountsToast.defaultProps = {
  updatedFilters: [],
  discounts: []
};

export default withCookie(COOKIE_CONFIG)(CityDiscountsToast);
